import React, { useState } from "react";
import AdminLayout from "../../layout";
import { Box, Flex, Image, Stack } from "@chakra-ui/react";
import CustomText from "../../components/Text/CustomText";
import { SummaryBox } from "../../components/Cards/SummaryBox";
import { useLocation, useNavigate } from "react-router-dom";
import { USER_ACTIVITY } from "../../utils/constants";
import TickIcon from "../../assets/tick-icon.svg";
import UserImg from "../../assets/user-pic.png";
import LeftArrow from "../../assets/left-arrow.svg";
import RightArrow from "../../assets/right-arrow.svg";
import { BackButton } from "../../components/Buttons/BackButton";
import Pagination from "../../components/Pagination";
import CustomButton from "../../components/Buttons/CustomButton";
import UserDetailHeader from "../../components/Cards/UserDetailHeader";

const UserActivity = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state;

  const [toastContent, setToastContent] = useState({
    icon: "",
    text: "",
    textColor: "",
  });

  const [pageSize, setPageSize] = useState(9); // Number of items per page
  const [currentPage, setCurrentPage] = useState(1); // Current page

  const totalPages = Math.ceil(USER_ACTIVITY.length / pageSize);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentTransactions = USER_ACTIVITY.slice(startIndex, endIndex);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle Previous Page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <AdminLayout
      icon={toastContent.icon}
      text={toastContent.text}
      textColor={toastContent.textColor}
    >
      <Stack align={"flex-start"} maxW={"1049px"} gap={"23px"}>
        <CustomText text={"User Wallets"} size="16px" w="600" />
        <Box
          p={"34px 0px 46px 36px"}
          mt={"23px"}
          borderRadius={"5px"}
          bg={"light.bg"}
          w={"100%"}
        >
          <UserDetailHeader
            date={userData?.date}
            email={userData?.email}
            id={"pay-60001987"}
          />
          <Flex gap={"73px"} align={"flex-start"} mt={"24px"}>
            <Stack align={"flex-start"} gap={"22px"}>
              <Image src={UserImg} alt="user-pic" w={"240px"} h={"154px"} />

              <BackButton
                title="Exit to main user directory"
                onClick={() => navigate("/user-summary")}
              />
            </Stack>
            <Stack align={"flex-start"} gap={"22px"}>
              <SummaryBox title="App Version" desc={`2.0.2`} icon={true} />
              <SummaryBox
                title="Last Logged in"
                desc={`${userData?.date}, 05:47 PM`}
                desc2="Yesterday"
              />

              <CustomButton text="Download User Activity" bgColor="light.bg" />
              <CustomButton text="Logout User" bgColor="light.bg" />
            </Stack>
            <Stack align={"flex-start"} gap={"22px"}>
              <SummaryBox title="Role" desc={`User`} />

              <CustomButton
                text={
                  userData?.status === "Enabled"
                    ? "Disable user"
                    : "Enable user"
                }
                bgColor="light.bg"
                textColor={userData?.status === "Enabled" ? "#FF000D" : ""}
                hoverBg={
                  userData?.status === "Enabled" ? "#F00" : "light.primary"
                }
                textColorHover={
                  userData?.status === "Enabled" ? "light.bg" : ""
                }
                onClick={() =>
                  setToastContent({
                    icon: TickIcon,
                    text:
                      userData?.status === "Enabled"
                        ? "User disabled!"
                        : "User enabled!",
                    textColor:
                      userData?.status === "Enabled" ? "#F00" : "light.primary",
                  })
                }
              />
              <BackButton
                title="Exit to user summary page"
                onClick={() => navigate("/user-summary")}
              />
            </Stack>
          </Flex>
        </Box>
        <Stack gap={"10px"} align={"flex-start"} w={"100%"}>
          <Box
            w={"100%"}
            pl={"32px"}
            py={"12px"}
            borderRadius={"5px"}
            bg={"light.bg"}
            boxShadow={"0px 4px 40px 0px rgba(0,0,0,0.02)"}
          >
            <CustomText text="User Activity History" size="15px" w="500" />
            <Flex
              align={"center"}
              gap={"143px"}
              h={"36px"}
              //   justify={"center"}
              alignItems={"center"}
              my={"18px"}
            >
              <Box w={"121px"}>
                <CustomText text="Date and Time" size="13px" w="500" />
              </Box>
              <Box w={"248px"}>
                <CustomText text="Type" size="13px" w="500" />
              </Box>
              <Box w={"161px"}>
                <CustomText text="Description" size="13px" w="500" />
              </Box>
            </Flex>
            {currentTransactions?.map((activity) => (
              <Flex
                align={"center"}
                gap={"120px"}
                h={"44px"}
                //   justify={"center"}
                alignItems={"center"}
                my={"5px"}
              >
                <Box w={"142px"}>
                  <CustomText text={activity?.date} size="13px" lh="18px" />
                </Box>
                <Box w={"274px"}>
                  <CustomText text={activity?.category} size="13px" lh="18px" />
                </Box>
                <Box w={"254px"}>
                  <CustomText text={activity?.action} size="13px" lh="18px" />
                </Box>
              </Flex>
            ))}
          </Box>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            onPageSizeChange={(newSize: any) => {
              setPageSize(newSize);
              setCurrentPage(1); // Reset to page 1 when page size changes
            }}
            onPreviousPage={handlePreviousPage}
            onNextPage={handleNextPage}
            leftArrowIcon={LeftArrow}
            rightArrowIcon={RightArrow}
          />
        </Stack>
      </Stack>
    </AdminLayout>
  );
};

export default UserActivity;
